import actions from "./action_types";
import axios from "axios";
import mutations from "./mutation_types";

export default {
    [actions.SET_CURRENCIES_STATE]: function(store, input_data) {
        store.commit(mutations.SET_CURRENCIES, input_data);
    },
    async [actions.ADD_TARIFF_TYPE] (store, input_data) {
        store.commit(mutations.ADD_TARIFF_TYPE, input_data);
        store.commit(mutations.SET_TARIFFS_NAMES);

    },
    async [actions.DELETE_TARIFF] (store, input_data) {
        store.commit(mutations.DELETE_TARIFF, input_data)
        store.commit(mutations.SET_TARIFFS_NAMES);
    }

}